import * as React from 'react';
import { memo } from 'react';
const EmptyAgentsImage = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={131} height={130} fill="none" {...props}>
        <path
            fill="#1B1B1B"
            d="M30.478 104.2a2.437 2.437 0 0 1-2.432-2.629l7.561-95.248a2.437 2.437 0 0 1 4.859.385l-7.56 95.248a2.436 2.436 0 0 1-2.427 2.244h-.001Z"
        />
        <path
            fill="#303030"
            d="M72.916 112.579a2.439 2.439 0 0 1-2.31-1.659L38.513 15.57l-21.217 95.102a2.437 2.437 0 0 1-4.756-1.061L35.657 5.985a2.437 2.437 0 0 1 4.688-.247l34.88 103.627a2.439 2.439 0 0 1-2.31 3.216v-.002Z"
        />
        <path
            fill="#474747"
            d="M63.051 61.542H18.597c-.595 0-1.078.483-1.078 1.078v3.468c0 .595.483 1.078 1.078 1.078h44.454c.595 0 1.078-.483 1.078-1.078V62.62c0-.595-.483-1.078-1.078-1.078Z"
        />
        <path
            fill="#5E5E5E"
            d="M59.23 11.315H22.42a1.5 1.5 0 0 0-1.5 1.499v47.228a1.5 1.5 0 0 0 1.5 1.5h36.81a1.5 1.5 0 0 0 1.5-1.5V12.814a1.5 1.5 0 0 0-1.5-1.5Z"
        />
        <path
            fill="#E84D4F"
            d="M32.805 58.922c-.596 0-1.08-.484-1.08-1.08v-3.04a1.08 1.08 0 0 1 2.16 0v3.04a1.08 1.08 0 0 1-1.08 1.08Z"
        />
        <path
            fill="#fff"
            d="M53.551 49.344a.56.56 0 0 0-.284.077 2.198 2.198 0 0 0-4.125-.462 1.323 1.323 0 0 0-2.231 1.096h7.187a.565.565 0 0 0-.547-.71Z"
        />
        <path
            fill="#E84D4F"
            d="M48.843 58.922c-.597 0-1.081-.484-1.081-1.08v-3.04a1.08 1.08 0 0 1 2.161 0v3.04a1.08 1.08 0 0 1-1.08 1.08Z"
        />
        <path
            fill="#1B1B1B"
            d="M48.575 55.624a2.162 2.162 0 0 1-2.157-2.037c-.206-3.552-.974-13.468-2.037-16.657-.312-.935-1.553-1.668-1.936-1.849a4.894 4.894 0 0 0-3.57.133 5.744 5.744 0 0 0-2.317 2.351c-.302.59-1.041 2.647-1.405 9-.209 3.635-.184 6.847-.184 6.878a2.162 2.162 0 0 1-2.143 2.18h-.018a2.161 2.161 0 0 1-2.161-2.144c-.012-1.395-.052-13.742 2.062-17.881a9.907 9.907 0 0 1 4.368-4.317l.022-.01a9.197 9.197 0 0 1 7.005-.187c.345.148 3.4 1.53 4.384 4.479 1.436 4.309 2.173 16.407 2.251 17.772a2.163 2.163 0 0 1-2.034 2.284c-.043.003-.084.003-.127.003l-.003.002Z"
        />
        <path
            fill="#1B1B1B"
            d="m34.176 45.184-.508 16.358h14.4L47.7 49.434 46.56 34.812l-7.677-2.514-4.706 2.971v9.915Z"
        />
        <path fill="#E84D4F" d="M40.62 29.677a3.035 3.035 0 1 0 0-6.07 3.035 3.035 0 0 0 0 6.07Z" />
        <path
            fill="#1B1B1B"
            d="M43.515 21.99c0 1.56-1.264 2.573-2.825 2.573-1.56 0-2.824-1.012-2.824-2.572s1.264-2.311 2.825-2.311c1.56 0 2.824.752 2.824 2.31Z"
        />
        <path fill="#1B1B1B" d="M43.514 21.99h-5.648v2.573h5.648v-2.572Z" />
        <path
            fill="#1B1B1B"
            d="M40.786 24.997c-.99.01-1.978-.046-2.96-.167-.42-.063-1.496-.451-1.618-.496a.269.269 0 0 1-.161-.346.269.269 0 0 1 .346-.162c.495.187 1.001.344 1.515.47 1.44.216 4.248.217 5.564 0 .467-.126.924-.281 1.371-.467a.27.27 0 1 1 .203.502h-.002c-.11.045-1.093.434-1.483.498-.92.124-1.846.18-2.774.167l-.001.001Z"
        />
        <path
            fill="#00D639"
            d="M40.646 28.843a1.815 1.815 0 1 0 0-3.63 1.815 1.815 0 0 0 0 3.63Z"
        />
        <path
            fill="#00D639"
            d="M40.775 25.215a1.014 1.014 0 0 0-1.18-1.306 1.014 1.014 0 0 0 1.18 1.306Z"
        />
        <path
            fill="#00D639"
            d="M42.218 23.769a1.31 1.31 0 0 0-1.634 1.588 1.31 1.31 0 0 0 1.624-.898c.065-.226.068-.464.01-.692v.002Z"
        />
        <path
            fill="#fff"
            d="M31.149 27.49a.56.56 0 0 0-.284.077 2.198 2.198 0 0 0-4.126-.462 1.322 1.322 0 0 0-2.23 1.096h7.188a.565.565 0 0 0-.546-.71h-.002ZM55.492 19.19c-.1 0-.198.027-.284.077a2.198 2.198 0 0 0-4.126-.462 1.323 1.323 0 0 0-2.23 1.096h7.188a.565.565 0 0 0-.547-.711h-.001Z"
        />
        <path
            fill="#B26E3D"
            d="M100.911 41.046a2.367 2.367 0 0 1-2.204-3.23l6.796-17.396a2.368 2.368 0 0 1 4.41 1.723l-6.796 17.396a2.368 2.368 0 0 1-2.206 1.507Z"
        />
        <path
            fill="#C6C6C6"
            d="M98.607 44.047c-2.46 0-4.7-.991-6.335-1.992-2.008-1.23-4.147-3.085-6.358-5.515a66.52 66.52 0 0 1-6.27-8.184 4.735 4.735 0 0 1 1.464-6.533 4.735 4.735 0 0 1 6.532 1.464 58.436 58.436 0 0 0 4.635 6.161c3.85 4.426 5.867 5.04 6.244 5.12a4.734 4.734 0 0 1 3.183 8.915 8.675 8.675 0 0 1-3.097.563l.002.001Z"
        />
        <path
            fill="#5E5E5E"
            d="M75.472 125.786a6.086 6.086 0 0 1-6.072-6.608l5.89-68.556c.288-4.305 3.46-7.583 7.578-7.812a8.004 8.004 0 0 1 5.563 1.838 8.517 8.517 0 0 1 2.926 5.167l.02.133 9.889 68.084a6.088 6.088 0 0 1-12.048 1.75L84.41 86.679l-2.882 33.54a6.087 6.087 0 0 1-6.058 5.566l.002.001Z"
        />
        <path
            fill="#5E5E5E"
            d="M93.892 124.709c-.19 0-.38-.042-.553-.12l-7.2-3.241a1.352 1.352 0 1 1 1.11-2.466l7.2 3.24a1.354 1.354 0 0 1-.557 2.588v-.001ZM73.931 125.458c-.174 0-.348-.034-.51-.101l-7.815-3.188a1.353 1.353 0 0 1 1.021-2.505l7.815 3.189a1.354 1.354 0 0 1-.51 2.605Z"
        />
        <path
            fill="#B26E3D"
            d="M84.323 15.426a2.518 2.518 0 1 1-4.79 1.558 2.518 2.518 0 0 1 4.79-1.558Z"
        />
        <path
            fill="#474747"
            d="M83.784 11.945a1.063 1.063 0 1 1-2.017.659 1.063 1.063 0 0 1 2.016-.659h.001ZM81.145 13.812a2.5 2.5 0 0 0-1.275.94 2.503 2.503 0 0 0-.373.787l4.859.006c-.011-.04-.02-.08-.033-.118a2.518 2.518 0 0 0-3.174-1.615h-.004Z"
        />
        <path
            fill="#B26E3D"
            d="M68.702 47.004a2.25 2.25 0 0 1-.361-.028l-12.902-1.972a2.366 2.366 0 0 1 .715-4.68l12.901 1.972a2.368 2.368 0 0 1-.355 4.708h.002Z"
        />
        <path
            fill="#C6C6C6"
            d="M69.697 49.67a4.734 4.734 0 1 1-.008-9.468c2.063-.008 4.482-.242 5.705-.53.635-1.676 1.443-5.72 1.825-9.301.013-.123.031-.246.053-.367.364-1.959.968-3.155 1.64-4.022a4.734 4.734 0 0 1 9.46-.407c.123 2.33-.14 4.258-1.759 6.005v.009a83.048 83.048 0 0 1-.847 5.596c-1.191 6.303-2.553 8.334-3.729 9.49-1.554 1.528-3.937 2.354-7.973 2.76a49.73 49.73 0 0 1-4.356.233h-.01v.002Z"
        />
        <path
            fill="#C6C6C6"
            d="M80.952 21.938s-5.45 2.75-3.741 20.727c0 0 4.48 5 9.838 2.228 5.357-2.771 1.109-11.06 1.109-11.06l-3.418-11.11-3.787-.784-.001-.002Z"
        />
        <path
            fill="#474747"
            d="M111.735 8.977c-5.058-1.627-10.479 1.155-12.106 6.214a9.63 9.63 0 0 0-.249 4.96 3.467 3.467 0 0 0 4.126 2.65c.028-.005.056-.013.085-.018a6.24 6.24 0 0 1 6.4 2.227 3.46 3.46 0 0 0 4.857.595l.065-.051c4.096-3.384 4.675-9.448 1.291-13.545a9.63 9.63 0 0 0-4.469-3.032Z"
        />
        <path
            fill="#00D639"
            d="M102.558 17.693a1.192 1.192 0 1 0 0-2.384 1.192 1.192 0 0 0 0 2.384Z"
        />
        <path
            fill="#1B1B1B"
            d="M105.905 14.201a1.191 1.191 0 1 0 0-2.382 1.191 1.191 0 0 0 0 2.382Z"
        />
        <path
            fill="#303030"
            d="M111.241 14.53a1.191 1.191 0 1 0 .001-2.383 1.191 1.191 0 0 0-.001 2.383Z"
        />
        <path
            fill="#fff"
            d="M114.283 18.234a1.191 1.191 0 1 0 .001-2.383 1.191 1.191 0 0 0-.001 2.383Z"
        />
        <path fill="#B26E3D" d="M107.572 20.63a.95.95 0 1 0-.001-1.9.95.95 0 0 0 .001 1.9Z" />
        <path
            fill="#B26E3D"
            d="M107.571 20.51a.832.832 0 0 1-.708-1.264l1.217-1.986a.832.832 0 0 1 1.417.867l-1.217 1.987a.827.827 0 0 1-.709.396Z"
        />
        <path
            fill="#00D639"
            d="M50.815 34.433a1.313 1.313 0 0 0 1.268 1.894 1.313 1.313 0 0 0-1.268-1.894Z"
        />
        <path
            fill="#1B1B1B"
            d="M55.297 41.734a.522.522 0 0 1-.435-.236c-.321-.49-3.135-4.787-3.266-5.005a.52.52 0 0 1 .89-.534c.098.163 1.994 3.061 3.243 4.97a.52.52 0 0 1-.433.805h.001Z"
        />
    </svg>
);
const Memo = memo(EmptyAgentsImage);
export default Memo;
